export default {
    alignV: {
        type: String,
        validator(value) {
            return ["start", "center", "end", "baseline", "stretch"].includes(
                value
            );
        },
        default: null,
    },
    alignH: {
        type: String,
        validator(value) {
            return [
                "start",
                "center",
                "end",
                "evenly",
                "around",
                "between",
            ].includes(value);
        },
        default: null,
    },
    cols: {
        type: String,
        validator(value) {
            return "1 2 3 4 5 6".includes(value);
        },
        default: null,
    },
    colsXl: {
        type: String,
        validator(value) {
            return "1 2 3 4 5 6".includes(value);
        },
        default: null,
    },
    colsLg: {
        type: String,
        validator(value) {
            return "1 2 3 4 5 6".includes(value);
        },
        default: null,
    },
    colsMd: {
        type: String,
        validator(value) {
            return "1 2 3 4 5 6".includes(value);
        },
        default: null,
    },
    colsSm: {
        type: String,
        validator(value) {
            return "1 2 3 4 5 6".includes(value);
        },
        default: null,
    },
};
